import request from '@/utils/request'
// 轮播图
export function slideshow(params) {
    return request({
        url: '/api/video/getBannerList',
        method: 'get',
        params
    })
}
// 流行数据
export function server(params) {
    return request({
        url: '/api/video/indexdatanew',
        method: 'get',
        params
    })
}
// 获取信息
export function userdata (params) {
    return request({
        url: '/api/user/index',
        method: 'get',
        params
    })
}
// 全部数据
export function overall (params) {
    return request({
        url: '/api/video/videosearch',
        method: 'get',
        params
    })
}
// 收藏
export function enshrine (params) {
    return request({
        url: '/api/user/videorecord',
        method: 'get',
        params
    })
}

// 账号注册登录
export function accountregister (data) {
    return request({
        url: '/api/user/accountregister',
        method: 'post',
        data
    })
}
// 退出登录
export function logout (data) {
    return request({
        url: '/api/user/logout',
        method: 'post',
        data
    })
}
// 获取观看记录
export function videoLog (params) {
    return request({
        url: '/api/video/videoLogList',
        method: 'get',
        params
    })
}
// 获取收藏记录
export function videoRecord (params) {
    return request({
        url: '/api/video/videoRecordList',
        method: 'get',
        params
    })
}
// 获取单剧详情
export function videoinfo (params) {
    return request({
        url: '/api/video/videoinfo',
        method: 'get',
        params
    })
}
// 播放记录
export function bfjl (params) {
    return request({
        url: '/api/video/bfjl',
        method: 'get',
        params
    })
}
// 获取视频推荐
export function videoRecommend (data) {
    return request({
        url: '/api/video/videoRecommend',
        method: 'post',
        data
    })
}
// 支付
export function rechargeConfig (params) {
    return request({
        url: '/api/pay/rechargeConfig',
        method: 'get',
        params
    })
}
// 贝宝支付
export function paypal (data) {
    return request({
        url: '/api/pay/paypal',
        method: 'post',
        data
    })
}
// usdt
export function createMapiPayment (data) {
    return request({
        url: '/api/Payment/createMapiPayment',
        method: 'post',
        data
    })
}
export function createSubmitPayment (data) {
    return request({
        url: '/api/Payment/createSubmitPayment',
        method: 'post',
        data
    })
}